module.exports = __webpack_public_path__ + "img/finance_20.3913035c.png";